import { render, staticRenderFns } from "./AudioUploadBase.vue?vue&type=template&id=42035af7"
import script from "./AudioUploadBase.vue?vue&type=script&lang=js"
export * from "./AudioUploadBase.vue?vue&type=script&lang=js"
import style0 from "./AudioUploadBase.vue?vue&type=style&index=0&id=42035af7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports